// src/helpers/pdfCommonSanPancracio.js

// Formato de fecha común
export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("es-AR") : "-";

// Formato numérico común
export const fmtNum = (n, dec = 2) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  });

// Conversión a string segura para jsPDF.text()
export const S = (v) => {
  if (v == null) return "";
  if (typeof v === "string") return v;
  if (v instanceof Date) return v.toLocaleDateString("es-AR");
  if (typeof v === "number") return v.toLocaleString("es-AR");
  if (typeof v === "boolean") return v ? "Sí" : "No";

  // objetos típicos que usás
  if (v.razonsocial) return String(v.razonsocial);
  if (v.transporte) return String(v.transporte);
  if (v.empresa) return String(v.empresa);
  if (v.nombre) return String(v.nombre);
  if (v.localidad) return String(v.localidad);
  if (v.provincia) return String(v.provincia);

  return String(v);
};

/** Carga imagen como dataURL; si falla, devuelve null. */
export async function loadImageAsDataURL(url) {
  if (!url) return null;
  try {
    const resp = await fetch(url, { mode: "cors" });
    if (!resp.ok) return null;
    const ct = resp.headers.get("content-type") || "";
    if (!ct.startsWith("image/")) return null;

    const blob = await resp.blob();
    const dataURL = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(blob);
    });
    return dataURL; // "data:image/png;base64,..."
  } catch {
    return null;
  }
}

// Encabezado común (igual estilo que Remitos)
export function drawHeader(doc, y, logoDataURL, empresa) {
  const pageW = doc.internal.pageSize.getWidth();

  // Logo a la izquierda
  if (logoDataURL) {
    try {
      doc.addImage(logoDataURL, "PNG", 12, y, 38, 18);
    } catch {
      /* sin logo, seguimos */
    }
  }

  const titulo = S(
    empresa?.nombre ?? empresa?.razonsocial ?? "SAN PANCRACIO SRL"
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(titulo, pageW / 2, y + 7, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  // 🔹 Línea 1: solo dirección
  const lineaDir = S(empresa?.direccion) || "";

  // 🔹 Línea 2: teléfono + email
  const lineaContacto = [S(empresa?.telefono), S(empresa?.email)]
    .filter(Boolean)
    .join("  •  ");

  let yInfo = y + 13;
  if (lineaDir) {
    doc.text(lineaDir, pageW / 2, yInfo, { align: "center" });
    yInfo += 5; // bajamos para la siguiente línea
  }
  if (lineaContacto) {
    doc.text(lineaContacto, pageW / 2, yInfo, { align: "center" });
  }

  // Línea separadora un poquito más abajo
  doc.setDrawColor(50);
  doc.line(12, y + 24, pageW - 12, y + 24);
}

